export function formatSkillName(name) {
  if (!name) return 'Untitled Skill';
  return name
    .split(/[-_]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getSkillName(skill) {
  return formatSkillName(skill?.name || skill?.skill_name);
}

export function getSkillId(skill) {
  return skill?.skill_id || skill?.skillId || skill?._id || skill?.id;
}

export function normalizeSkillsList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.skills)) return data.skills;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.detail)) return data.detail;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

export function normalizeSkillDetail(response) {
  if (!response || typeof response !== 'object') return null;
  return response?.skill || response?.detail || response?.data || response;
}
